import React from 'react';
import PropTypes from 'prop-types';
import withHeadlineProps from './headlineProps';
import './headline.scss';

/**
 * H5 text component
 */

export function H5(props) {
	return (
		<h5 className={props.className}>
			{props.children}
		</h5>
	);
}

H5.propTypes = {
	className: PropTypes.string,
	children: PropTypes.node
};

export default withHeadlineProps(H5);
